/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */
import {
  coverGlass,
  frostGlass,
  coverButton,
  ctrlBarWidth,
  tabItemH_P,
  niceScrollbar,
} from "./classroomStyle";

import { largeLandscape } from "assets/jss/material-kit-pro-react.jsx";

const styles = (theme) => {
  const secondaryColor = theme.palette.secondary.main;
  const notesColorDark = theme.palette.notes.dark;
  const notesColor = theme.palette.notes.main;
  const notesColorLight = theme.palette.notes.light;
  const notesBackground = theme.palette.notes.background;

  return {
    "@global": niceScrollbar,

    notesCover: {
      ...coverGlass,
      "&:before": {
        ...frostGlass["&:before"],
        filter: "blur(3px)",
        boxShadow: "inset 0 0 0 800px rgba(255,145,20,0.1)",
      },
    },

    notesCoverButton: {
      ...coverButton,
      "&:hover": { background: notesColorDark },
      background: notesColor,
    },

    // 2nd line in the Notes Cover Button
    notesCoverButton2: {
      display: "flex",
      alignItems: "center",
      "@media (orientation: portrait)": {
        fontSize: "3vh",
      },
      fontSize: "1.5vw",
      lineHeight: "150%",
    },

    notesPanel: {
      display: "grid",
      [largeLandscape]: {
        gridTemplateRows: "100%",
        gridTemplateColumns: `1fr ${ctrlBarWidth}`,
        gridTemplateAreas: "'notesList notesCtrl'",
        minHeight: "100%",
      },
      gridTemplateColumns: "100%",
      gridTemplateRows: `${ctrlBarWidth} 1fr`,
      gridTemplateAreas: "'notesCtrl' 'notesList'",

      width: "100%",
      ...tabItemH_P, // set minHeight
      position: "relative",
    },

    notesList: {
      gridArea: "notesList",
      width: "100%",
      height: "100%",
      margin: "0 auto",
      overflow: "auto",
      position: "absolute",
    },

    notesCtrl: {
      gridArea: "notesCtrl",
      [largeLandscape]: {
        width: ctrlBarWidth,
        height: "100%",
      },
      height: ctrlBarWidth,
      width: "100%",
      backgroundColor: notesColor,
    },

    addButton: {
      backgroundColor: notesColor,
      color: "white",
      "&:hover": { background: notesColorDark },
      position: "absolute",
      right: "4rem",
      top: "-0.3rem",
    },

    nzResizeButton: {
      backgroundColor: notesColor,
      color: "white",
      "&:hover": { background: notesColorDark },
      position: "absolute",
      right: "10px",
      top: "-5px",
    },

    noteLabel: {
      boxShadow: "inset 0 3px 3px rgba(0,0,0, 0.2)",
    },

    noteLabelExp: {
      maxHeight: "2.8rem",
      backgroundColor: notesBackground,
    },

    noteBodyPanel: {
      width: "100%",
      padding: "0 4px",
      backgroundColor: notesBackground,
      borderLeft: "1px solid #E3E3EE",
      borderRight: "1px solid #DBDAE1",
    },

    noteBody: {
      margin: "-16px 0 0 0",
      display: "flex",
      alignItems: "flex-end",
      width: "100%",
    },

    noteBodyEdit: {
      "@media (min-width: 420px)": {
        minWidth: "89%",
      },
      minWidth: "78%",
    },

    labelRoot: {
      margin: "0 0 4px",
    },

    // Notes label, attribute of input element
    labelAttr: {
      "&:hover": {
        borderBottom: `1px solid ${notesColorDark}`,
      },
      "&:focus": {
        borderBottom: `2px solid ${notesColor}`,
      },
      padding: "2px 8px",
    },

    // Notes text, attribute of input element
    textAttr: {
      "&:hover": {
        border: `1px solid ${notesColorDark}`,
      },
      "&:focus": {
        border: `2px solid ${notesColor}`,
      },
      border: "1px solid #D0D0D0",
      borderRadius: "3px",
      padding: "10px",
      minHeight: "2.5rem",
      backgroundColor: "#FFFFFF",
    },

    inputRoot: {
      margin: "0 3.5rem 4px auto",
    },

    ctrlButton: {
      "&:hover": { background: notesColorDark },
      color: "white",
      margin: "0 2px",
      padding: "6px",
    },

    ctrlIcon: {
      fontSize: "36px",
    },

    notesColor: { color: notesColor, paddingRight: 0 },
    colorInherit: { backgroundColor: notesColor },

    vbButton: {
      "&:hover": {
        color: "white",
        backgroundColor: secondaryColor,
      },
      color: secondaryColor,
      backgroundColor: "white",
      "@media (min-width: 768px)": {
        margin: "auto 2px auto 8px",
      },
      margin: "auto 2px auto 6px",
    },

    colorPal: { width: "24px", height: "24px" },

    doneButton: { width: "20px", height: "20px" },
  };
};

export default styles;
